import { render, staticRenderFns } from "./BaseBox.vue?vue&type=template&id=64d944c0&scoped=true&"
import script from "./BaseBox.vue?vue&type=script&lang=js&"
export * from "./BaseBox.vue?vue&type=script&lang=js&"
import style0 from "./BaseBox.vue?vue&type=style&index=0&id=64d944c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d944c0",
  null
  
)

export default component.exports